import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import { MDBBtn, MDBDatatable, MDBIcon, MDBSpinner, MDBInput, MDBSelect, MDBRow, MDBCol, MDBRadio, MDBTextArea, MDBModal, MDBModalDialog, MDBModalContent, MDBModalTitle, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCheckbox, MDBCard, MDBCardHeader, MDBCardBody, MDBCardTitle } from "mdb-react-ui-kit";
import { useLocation, useNavigate } from "react-router";
import { deleteBillingInfo, getAllBillingGroups } from "../../apiclients/streamsapi_bridge"
import PopupLoaderNew from "../popups/PopupLoaderNew";
import DeleteBilling from "../popups/billinggroups/DeleteBillingGroup";
import AddBillingGroup from "../popups/billinggroups/AddBillingGroup";
import { useSearchParams } from "react-router-dom";
import TopSuccess from "../../components/header/TopSuccess";
import TopMessage from "../../components/header/TopMessage";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import { getStreamsProductName } from "../../apiclients/CommonUtils";
import TabIDConstant from "../../apiclients/TabIDConstant";
function BillingLandingPage(props) {
  const [rowdata, setRowData] = useState([]);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [gname, setgname] = useState("")
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [deleteGroupDependency, setdeleteGroupDependency] = useState({});
  const [billinggrpInfo, setbillinggrpInfo] = useState({});
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [uniqueKey, setUniqueKey] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const streamsProductName = getStreamsProductName();
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
  const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)

  const billRef = useRef(null);

  function handleClick() {
    billRef.current.click();
  }

  const [deleteGroup, setDeleteGroup] = useState(false);
  const toggleBillingGroup = () => setDeleteGroup(!deleteGroup)
  const handleDeleteGroup = (e, group) => {
    e.stopPropagation();
    e.preventDefault();
    handleDeleteBillingGroup(group);
    // setSelectedGroupId(group?.billing_group_id);
    // setgname(group?.billing_group_name)
    // setDeleteGroup(!deleteGroup)
  };

  async function handleDeleteBillingGroup(group) {

    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    setIsloading(true);
    let update = {
      reqid: 141,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      bgrp_id: parseInt(group?.billing_group_id),
      confirm: false,

    }

    console.log("handleDeleteBillingGroup value  :::: " + JSON.stringify(update));
    let deleteJson = await deleteBillingInfo(update);
    setIsloading(false);

    let deleteMsg = await deleteJson.json();
    console.log("Response... ");
    console.log("response to remove the filter :::::::::::::; " + JSON.stringify(deleteMsg));

    if (deleteMsg.status === "success") {
      setdeleteGroupDependency(deleteMsg ?? {});
      setDeleteGroup(!deleteGroup)
      setbillinggrpInfo(group);
    } else {


    }


  }



  const [addGroup, setAddGroup] = useState(false);
  const toggleAddBillingGroup = (e) => setAddGroup(!addGroup);
  const [isloading, setIsloading] = useState(false);
  const [deleteBGroup, setDeleteBGroup] = useState(false);
  const [isLoading, setisLoading] = useState(false);

  async function loadData(uniqueKeyParam) {
    try {
      setIsloading(true)
      const response = await getAllBillingGroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        uniqueKeyParam,
        TabIDConstant.BILLING_GRPS_LINK
      );
      const rawData = await response.json();
      setIsloading(false);

      if (rawData?.display_msg) {
        setSuccessMessage(rawData.display_msg);
      }
      const data = rawData.all_billing_groups.map((group) => ({
        groupInfo: group,
        group: group.billing_group_name + (group.default_billing ? " (Default)" : ""),
        // defaultgroup: (
        //   <div>
        //     {group.default_billing && (
        //       <>
        //       <div className="d-flex">
        //         <div className="px-2 ms-2 border border-1 rounded-pill border-success text-center">
        //           <span className="small text-success">Primary</span>
        //         </div>
        //       </div>
        //       </>
        //     )}

        //   </div>
        // ),
        groupType: group?.billing_group_type,
        remove: (
          <>
            {!group.default_billing && (
              <div className="d-flex align-items-center ms-2" onClick={(e) => handleDeleteGroup(e, group)}>
                <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
                  <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                </div>
              </div>
            )}
          </>
        ),
      }));

      if (response.status === 200) {
        setRowData(data);
        setFilteredRows(data)
        setDataLoaded(true)

      } else if (response.status === 500) {
        // setInternalError(true);
      } else {
        navigate("/");
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
    } finally {
      setIsloading(false);
    }

  }

  useEffect(() => {
    // Check for unique_key parameter in the URL
    const uniqueKeyParam = searchParams.get('uniqueKey');

    if (uniqueKeyParam) {
      // Set the unique key in state
      setUniqueKey(uniqueKeyParam);
      // Remove the query parameter from the URL without reloading the page
      searchParams.delete('uniqueKey');
      setSearchParams(searchParams, { replace: true });

      // Load data with the unique key
      loadData(uniqueKeyParam);
    } else {
      // Normal load without unique key
      loadData();
    }
  }, []);

  // useEffect(() => {
  //   loadData();
  // }, []);

  const handleRemove = (id) => {
    console.log(`Removing group with ID: ${id}`);
  };

  function showThisInfo(tdata) {
    navigate("/billinggroupdetails", {
      state: tdata.groupInfo
    })
  };

  const actionData = {
    columns: [
      { label: t('name'), field: "group", sort: true },
      // { label: "", field: "defaultgroup", sort: false, colSpan: 1 },
      {
        label: (
          <>
            <div className="d-flex align-items-center ">
              <div>
                {t('billing_Group_Type')}
              </div>
              <MDBIcon fas icon="info-circle" className="BillingGroupType ms-4" />
            </div>
          </>
        ), field: 'groupType', sort: true
      },
      { label: t('remove'), field: 'remove', sort: false },
    ],
    rows: rowdata,
  };

  const [optSmModal, setOptSmModal] = useState(false);

  const toggleOpen = () => setOptSmModal(!optSmModal);


  
  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue); 
      const filteredUsers = customSearch(rowdata, searchValue, UIConstant.BILLING_LANDING);
  
    setFilteredRows(filteredUsers);
  };


  const [cancelAccountName, setCancelAccountName] = useState('');
  const [cancelAccountEmail, setCancelAccountEmail] = useState('');
  const [cancelAccountPhone, setCancelAccountPhone] = useState('');
  const [cancelAccountReason, setCancelAccountReason] = useState('');
  const [cancelAccountComments, setCancelAccountComments] = useState('');
  const [cancelAccountPorting, setCancelAccountPorting] = useState('No');
  const [cancelAccountPortingNumbers, setCancelAccountPortingNumbers] = useState('');
  const [cancelAccountAdminName, setCancelAccountAdminName] = useState('');
  const [cancelAccountAdminInitials, setCancelAccountAdminInitials] = useState('');


  const handleSubmit = () => {
    const formData = {
      cancelAccountName,
      cancelAccountEmail,
      cancelAccountPhone,
      cancelAccountReason,
      cancelAccountComments,
      cancelAccountPorting,
      cancelAccountPortingNumbers,
      cancelAccountAdminName,
      cancelAccountAdminInitials
    };
    console.log('Submitting:', formData);
    setIsSubmitted(true);
  };

  const [isSubmitted, setIsSubmitted] = useState(false);



  return (
    <React.Fragment>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <MainLinks active={5} />
      <Body
        tablinks={5}
        sublink={297}
        content={
          <>
            <section className="mb-3">
              <div className="card card-height">
                <div className="card-header p-3 px-0 d-flex justify-content-between w-100">
                  <h5 className="mb-0">{t("billing_Groups")}</h5>
                  {/* <MDBBtn color="danger" outline onClick={toggleOpen}>Cancel Account</MDBBtn> */}
                </div>
                <div>
                  {!isWholesaleAcc &&
                  <div className="actionbar">
                    <MDBBtn onClick={toggleAddBillingGroup} >
                      <MDBIcon fas icon="plus" className="me-2" />
                      {t("Add Group")}
                    </MDBBtn>
                  </div>
                  }
                  <div className={`mb-2 position-relative ${isWholesaleAcc ? "w-300px" : "w-auto"}`}>
                    <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                  </div>
                  <div className="huntDataTable">
                    <MDBDatatable key={searchValue}
                      data={{
                        ...actionData,
                        rows: filteredRows, // Use filtered rows here
                      }}
                      className="actioncolumnbig"
                      entries={50}
                      sortField="group"
                      onRowClick={(event) => showThisInfo(event)}
                    />
                  </div>
                </div>
              </div>


              {deleteGroup && (
                <PopupLoaderNew
                  title={"Delete Billing Group"}
                  content={
                    <>
                      <DeleteBilling
                        ref={billRef}
                        deleteGroupDependency={deleteGroupDependency}
                        billinggrpInfo={billinggrpInfo}
                        onClose={toggleBillingGroup}
                        setIsloading={setisLoading}

                      />
                    </>
                  }
                  flag={10}
                  onSave={handleClick}
                  onShow={setDeleteGroup}
                  onClose={toggleBillingGroup}
                />
              )}

              {addGroup && (
                <PopupLoaderNew
                  title={"Add Billing Group"}
                  content={
                    <AddBillingGroup
                      ref={billRef}
                      onClose={toggleAddBillingGroup}
                      setIsloading={setisLoading}
                    />
                  }
                  flag={1}
                  onSave={handleClick}
                  onShow={setAddGroup}
                  onClose={toggleAddBillingGroup}
                />
              )}


              <MDBModal open={optSmModal} onClose={() => setOptSmModal(false)}>
                <MDBModalDialog size={isSubmitted ? "md" : "lg"}>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>
                        {isSubmitted ?
                          <>
                            Account cancellation request
                          </> : <>
                            {streamsProductName} Account Cancellation Form
                          </>
                        }
                      </MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                    </MDBModalHeader>
                    {!isSubmitted ? (
                      <MDBModalBody>
                        <p className="">
                          Thank you for using {streamsProductName}. Were sorry to see you go. Your account will be closed once you submit this form. You will receive an email confirming that it has been terminated. Please help us improve our service by answering the questions below.
                        </p>
                        <p className=" mt-3">
                          Please note: in the "Number Porting" section below, please be sure to carefully list the phone numbers you wish to keep from your {streamsProductName} account, if any. Please be aware: if you do not specifically list which numbers you wish to retain and port to your new service provider, we will make any of your {streamsProductName} numbers available to other {streamsProductName} accounts in the future. You will have no claim to these numbers in the future.

                        </p>


                        <MDBCard className="mt-4 shadow-0 border border-1 rounded-3 p-0 ">
                          <MDBCardHeader className="bg-secondary bg-opacity-10">
                            <MDBCardTitle style={{ fontSize: "16px" }} className="m-0">
                              Account Information
                            </MDBCardTitle>
                          </MDBCardHeader>
                          <MDBCardBody>
                            <div htmlFor="" className="fw-bold mb-3">Account Name: <span className="text-danger"> *</span>
                              <p className="d-inline ms-2">
                                pbxtesting
                              </p>
                            </div>

                            <MDBRow>
                              <MDBCol sm={12} md={6} lg={6}>
                                <label htmlFor="" className="fw-bold">Account Administrator Email<span className="text-danger"> *</span></label>
                                <MDBInput required type="email" className="mb-3" value={cancelAccountEmail} onChange={e => setCancelAccountEmail(e.target.value)} />
                              </MDBCol>
                              <MDBCol sm={12} md={6} lg={6}>
                                <label htmlFor="" className="fw-bold">Account Administrator Phone<span className="text-danger"> *</span></label>
                                <MDBInput required value={cancelAccountPhone} onChange={e => setCancelAccountPhone(e.target.value)} />
                                <span className=" m-0 mb-4 small">
                                  (please use a non-{streamsProductName} number where {streamsProductName} Customer Service can reach you)
                                </span>
                              </MDBCol>
                            </MDBRow>

                          </MDBCardBody>
                        </MDBCard>



                        <MDBCard className="mt-4 shadow-0 border border-1 rounded-3 p-0 ">
                          <MDBCardHeader className="bg-secondary bg-opacity-10">
                            <MDBCardTitle style={{ fontSize: "16px" }} className="m-0">
                              Please tell us why you chose to end your {streamsProductName} subscription
                            </MDBCardTitle>
                          </MDBCardHeader>
                          <MDBCardBody className="cancle-account">
                            <MDBCheckbox className="mb-2" id="cancelReason1" label='I have selected another hosted PBX solution.' value='hosted' onChange={e => setCancelAccountReason(e.target.value)} />
                            <MDBCheckbox className="mb-2" id="cancelReason2" label='I have selected another customer premise-based PBX solution.' value='premise' onChange={e => setCancelAccountReason(e.target.value)} />
                            <MDBCheckbox className="mb-2" id="cancelReason3" label='Our project/plans have been postponed.' value='postponed' onChange={e => setCancelAccountReason(e.target.value)} />
                            <MDBCheckbox className="mb-2" id="cancelReason4" label={`${streamsProductName} does not offer the features I am looking for. `} value='features' onChange={e => setCancelAccountReason(e.target.value)} />
                            <MDBCheckbox className="mb-2" id="cancelReason5" label={`${streamsProductName} costs more than I was prepared to spend. `} value='cost' onChange={e => setCancelAccountReason(e.target.value)} />
                            <MDBCheckbox className="mb-2" id="cancelReason6" label='Other reasons (specify in comments area below)' value='other' onChange={e => setCancelAccountReason(e.target.value)} />
                            <label htmlFor="" className="fw-bold mt-3">Additional Comments</label>
                            <MDBTextArea rows={3} className="mb-3" value={cancelAccountComments} onChange={e => setCancelAccountComments(e.target.value)} />
                          </MDBCardBody>
                        </MDBCard>

                        <MDBCard className="mt-4 shadow-0 border border-1 rounded-3 p-0 ">
                          <MDBCardHeader className="bg-secondary bg-opacity-10">
                            <MDBCardTitle style={{ fontSize: "16px" }} className="m-0">
                              Number Porting
                            </MDBCardTitle>
                          </MDBCardHeader>
                          <MDBCardBody>
                            <p className="">
                              Would you like to retain any of the phone numbers you purchased from {streamsProductName}?
                            </p>
                            <div className="d-flex gap-3">
                              <MDBRadio inline name='porting' label='Yes' value='Yes' checked={cancelAccountPorting === 'Yes'} onChange={e => setCancelAccountPorting(e.target.value)} />
                              <MDBRadio inline name='porting' label='No' value='No' checked={cancelAccountPorting === 'No'} onChange={e => setCancelAccountPorting(e.target.value)} />
                            </div>


                            <label htmlFor="" className="fw-bold mt-2">List the numbers you wish to retain</label>
                            <MDBTextArea rows={2} value={cancelAccountPortingNumbers} onChange={e => setCancelAccountPortingNumbers(e.target.value)} />

                            <MDBRow className="mb-3">
                              <MDBCol sm={12} md={6} lg={6}>
                                <label htmlFor="" className="fw-bold mt-3">Name of the Account Administrator<span className="text-danger"> *</span></label>

                                <MDBInput required value={cancelAccountAdminName} onChange={e => setCancelAccountAdminName(e.target.value)} />

                              </MDBCol>
                              <MDBCol sm={12} md={6} lg={6}>
                                <label htmlFor="" className="fw-bold  mt-3">Initials of Account Administrator</label>
                                <MDBInput required value={cancelAccountAdminInitials} onChange={e => setCancelAccountAdminInitials(e.target.value)} />
                              </MDBCol>
                            </MDBRow>

                          </MDBCardBody>
                        </MDBCard>



                        <p className="small  mt-2">
                          Entering your full initials verifies your identity and confirms that you wish to terminate your {streamsProductName} Main Account.
                        </p>
                        <p className="small  mt-3">
                          In case you change your mind, our systems will maintain information relating to your account for one month from the day that the account is closed. After this one month period, all information relating to your account will be purged from our systems.
                        </p>
                      </MDBModalBody>
                    ) : (
                      <MDBModalBody>

                        <MDBCard className="shadow-0 p-0">
                          <MDBCardBody>

                            <p className="mb-2"><strong>Dear pbxtesting</strong></p>
                            <p>
                              Thank you for your association with <strong>ucaccountfilter</strong>. We are sorry to know that you have opted to cancel your account. Your cancellation request is under process.
                            </p>
                            <p>
                              Meanwhile if you have any questions or suggestions, please feel free to contact us at: <strong>(800) 805-0558</strong> or mail to <strong>billing@panterranetworks.com</strong>
                            </p>
                            <p className="mt-2">Go to <a href="#">Login</a> page.</p>
                          </MDBCardBody>
                        </MDBCard>
                      </MDBModalBody>
                    )}

                    {!isSubmitted &&
                      <MDBModalFooter>
                        <MDBBtn color='secondary' onClick={toggleOpen}>Cancel</MDBBtn>
                        <MDBBtn color='danger' onClick={handleSubmit}>Submit</MDBBtn>
                      </MDBModalFooter>
                    }

                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>



            </section>

            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
              Remove
            </Tooltip>
            <Tooltip anchorSelect=".BillingGroupType" place="top" className="exampleTooltipLight w-30">
              This column indicates whether the billing group is an Invoice Group or a Subtotal Group.  An Invoice Group is the group which receives monthly billable invoice.  A Subtotal group receives only a Subtotal which will not be separately billed.
            </Tooltip>
            <Tooltip anchorSelect=".BillingGroupTypePopup" place="right" className="exampleTooltipLight w-30">
              <span className="BillingGroupTypePopup">
                <h5>Invoice:</h5> <ul><li>Invoice Groups can be created by choosing Individual Users, Account Level Items &amp; Flat Subtotal Groups.</li><li>Only Flat Subtotal Groups (i.e., a Subtotal Group that does not have other Subtotal groups nested in them) are available when creating an Invoice Group.  Subtotal Groups with nested Subtotal groups in them will NOT appear here.</li></ul>
                <h5 className="mt-0">Sub total:</h5><ul ><li>Subtotal Groups can be created by choosing Individual Users, Account Level Items, Invoice Groups and/or Subtotal Groups.</li><li>You can only choose Flat Invoice or Flat Subtotal Groups.  Subtotal Groups or Invoice Groups with nested groups in them will NOT appear here.</li></ul>
              </span>
            </Tooltip>

            {successMessage && (
              <>
                <TopSuccess>
                  <TopMessage successMessage={successMessage} />
                </TopSuccess>
              </>
            )}


          </>
        }
      />
    </React.Fragment>
  );
}

export default BillingLandingPage;
